module.exports = __webpack_public_path__ + "img/ac3_thumb.78e4d808.jpg";